<template>
  <div class="labels">
    <!-- <span class="labels__header">{{ label }}</span> -->
    <span v-if="requiredLabel" class="labels__required"
      ><em>*</em> - {{ $t("required_fields") }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    // label: {
    //   type: String,
    //   default: ""
    // },
    requiredLabel: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.labels {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  // padding: 20px 0;
  // margin-top: 30px;

  &__header {
    font-family: "Gilam SemiBold", sans-serif;
    font-size: 16px;
    color: #9d9d9d;
    letter-spacing: 6px;
  }

  &__required {
    font-size: 12px;
    color: $white-60;

    em {
      font-size: 16px;
      color: #ff0000;
    }
  }
}

@media screen and (min-width: $screen-sm) {
}
@media screen and (min-width: $screen-md) {
}
@media screen and (min-width: $screen-xl) {
}
</style>
